import { render, staticRenderFns } from "./MenuFooter.vue?vue&type=template&id=7010fc04&scoped=true"
import script from "./MenuFooter.vue?vue&type=script&lang=js"
export * from "./MenuFooter.vue?vue&type=script&lang=js"
import style0 from "./MenuFooter.vue?vue&type=style&index=0&id=7010fc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010fc04",
  null
  
)

export default component.exports